<div class="table-state">
  @if (isLoading()) {
    <div class="table-state__loading">
      <dsy-loader type="spinner" size="small" animation-speed="slow"></dsy-loader>
    </div>
  } @else if (hasData()) {
    <div class="table-state__table">
      <ng-content></ng-content>
    </div>

    <dr-ops-stream-ui-pagination [totalItems]="totalItems()" />
  } @else {
    <div class="table-state__empty">
      <dr-ops-stream-ui-empty-state [title]="emptyTitle()"></dr-ops-stream-ui-empty-state>
    </div>
  }
</div>
